export default __webpack_public_path__ + "static/Ewa Kryger-4282ed25c510b69aedbcee241a65e3d0.jpg";